export const ASSET_NAME = 'privacy-policy';

// Legal text is served from the in-repo privacyPolicyContent.json (see
// PrivacyPolicyPage.js) — the Console CMS copy is ignored, so there is
// nothing to fetch. Keeping a resolved loadData preserves the SSR contract.
export const loadData = (params, search) => dispatch => {
  return Promise.resolve();
};
